import i18n from '@/locales';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

// 其他时区的时分转换成北京时间
const tranfromToPekingTime = (time: string, time_zone: string) => {
    const [hour, minute] = time.split(':');
    const dayEnd = dayjs().endOf('day')
        .tz('Asia/Shanghai', true);
    const dayStart = dayjs().startOf('day')
        .tz('Asia/Shanghai', true);
    const date = dayjs().startOf('day').hour(+hour).minute(+minute)
        .tz(time_zone, true)
        .tz('Asia/Shanghai');
    // 昨日
    const isLastDay = date.isBefore(dayStart);
    if (isLastDay) {
        return `${i18n.t('setting.team.scheduleTable.lastDay')}${date.format('HH:mm')}`;
    }
    // 次日
    const isCrossDay = date.isAfter(dayEnd);
    if (isCrossDay) {
        return `${i18n.t('setting.team.scheduleTable.crossDay')}${date.format('HH:mm')}`;
    }
    return `${date.format('HH:mm')}`;
};

const timeDayjs = dayjs;

export default { tranfromToPekingTime };
export { tranfromToPekingTime, timeDayjs };
